<h2 mat-dialog-title>{{ 'orders.confirmSubmission' | transloco }}</h2>
<mat-dialog-content>
    <div class="margin-bottom-15">
        {{ customMessage ?? ('orders.areYouSureYouReReadyToSubmit' | transloco) }}
    </div>
    @if(showEmailOption) {
        <mat-checkbox class="margin-bottom-5" [(ngModel)]="sendEmail" (change)="onSendEmailToggled()"> {{ 'orders.sendMeAnEmailWhenThis' | transloco }}</mat-checkbox>
        @if (sendEmail) {
            <div class="flex-container-center">
                <mat-form-field class="flex-item form-field" appearance="outline">
                    <mat-label>{{ 'orders.emailAddresses' | transloco }}</mat-label>
                    <mat-chip-grid #emailChipGrid [formControl]="emailsControl"
                        [attr.aria-label]="'orders.emailAddressesToNotifyWhenThis' | transloco">
                        @for (email of emails; track email) {
                            <mat-chip-row (removed)="removeEmail(email)">
                                {{ email }}
                                <button matChipRemove [attr.aria-label]="'common.labels.removeItem' | transloco: { item: email }">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-row>
                        }
                        <input [formControl]="pendingEmail"
                            [matChipInputFor]="emailChipGrid"
                            [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="onEmailTokenEnd($event)"
                            (paste)="onEmailPaste($event)"
                            [placeholder]="'orders.addEmail' | transloco"
                            name="emailAddress">
                    </mat-chip-grid>
                    <mat-hint>{{ 'orders.pressEnterSpaceOrCommaTo' | transloco }}</mat-hint>
                    @if (emailsControl.hasError('invalidEmail')) {
                        <mat-error>{{ 'orders.invalidEmailAddress' | transloco: { email: pendingEmail.value } }}</mat-error>
                    } @else if (emailsControl.hasError('required')) {
                        <mat-error>{{ 'orders.enterAtLeastOneEmailAddress' | transloco }}</mat-error>
                    }
                </mat-form-field>
            </div>
            <br />
        }
    }
    @if(showReturnCheckbox){
        <mat-checkbox class="" [(ngModel)]="shouldReturnToBusinessSearchResults">{{ 'orders.returnToSearchResultsOnSubmission' | transloco }}</mat-checkbox>
        <br />
    }
    @if(showLinkToHubReportCheckboxes){
        @for (node of linkToUboTrees; track node.id) {
        <mat-checkbox [disabled]="!!uboTreeToLinkTo && uboTreeToLinkTo !== node" (change)="onHubReportCheckboxClick(node)">{{ 'orders.linkToHubReportBefore' | transloco }} <b>"{{node.hubReportReference}}"</b> {{ 'orders.onSubmission' | transloco }}</mat-checkbox>
        <br />
        }
    }
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close color="accent" [mat-dialog-close]="{ submit: false }"
        data-testid="negative-dialog-button">{{ 'common.buttons.close' | transloco }}</button>
    <span class="spacer"></span>
    <button mat-button color="accent" (click)="onSubmit()" [disabled]="sendEmail && emailsControl.invalid"
        data-testid="positive-dialog-button">{{ 'common.buttons.submit' | transloco }}</button>
</mat-dialog-actions>
